import { useEffect, useMemo, useRef, useState } from 'react'
import './style.scss'
import { InstructorProfileData } from '../../server/types'
import InstructorProfileAwards from '../../sections/instructorProfileAwards/InstructorProfileAwards'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import InstructorProfileThingsToKnow from '../../sections/instructorProfileThingsToKnow/InstructorProfileThingsToKnow'
import InstructorProfileRating from '../../sections/instructorProfileRating/InstructorProfileRating'
import InstructorProfileReviews from '../../sections/instructorProfileReviews/InstructorProfileReviews'
import { instructorProfileConnector } from '../../server/connector/instructorProfileConnector'
import { instructorStateData } from '../../data/instructorStateData'
import { getGenderStringFromIndex, getProfilePicCount, getProfilePicPathArr } from '../../constants/instructorConstants'
import { getAgeFromDateString } from '../../utils/Time'
import { userStateData } from '../../data/userStateData'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { updateLikedProfiles } from '../../redux/reducers/searchSlice'

class MouseData {
	mouseX: number = 0
	imageMoved: boolean = false
}

const mouseData: MouseData = new MouseData()

function AppInstructorProfile() {
	const [instructorProfileData, setInstructorProfileData] = useState<InstructorProfileData | undefined>(instructorStateData.profileData)
	const reviewCount: number = useAppSelector((state) => state.instructor.reviewCount)

	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)
	const innerHeight: number = useAppSelector(state => state.resize.innerHeight)
	const imgWrapRef = useRef<HTMLDivElement>(null)
	const [imgSliding, setImgSliding] = useState<boolean>(false)
	const [imgWrapRefWidth, setImgWrapRefWidth] = useState<number>(0)
	const [imgWrapRefHeight, setImgWrapRefHeight] = useState<number>(0)
	const [imgLeftMargin, setImgLeftMargin] = useState<number>(0)
	const [lastFirstImgLeftMargin, setLastFirstImgLeftMargin] = useState<number>(0)
	const [firstImgLeftMargin, setFirstImgLeftMargin] = useState<number>(0)

	const [imgIndex, setImgIndex] = useState<number>(0)

	const likedProfiles: string[] = useAppSelector(state => state.search.likedProfiles)
	const renderProfileLikes: number = useAppSelector(state => state.search.renderProfileLikes)
	const [profileIsLiked, setProfileIsLiked] = useState<boolean>(false)
	
	const dispatch = useAppDispatch()

	const toggleProfileLike = (profileId: string) => {
		userStateData.toggleLikesInstructor(profileId)
		dispatch(updateLikedProfiles())
	}

	useEffect(() => {
		requestProfile()
	}, [])

	useEffect(() => {
		if (instructorProfileData !== undefined) {
			let isLiked: boolean = false
			likedProfiles.forEach((value: string) => {
				if (value == instructorProfileData.id) {
					isLiked = true
				}
			})
			setProfileIsLiked(isLiked)
		} else {
			setProfileIsLiked(false)
		}
	}, [renderProfileLikes, instructorProfileData])

	useEffect(() => {
		setImgWrapRefWidth(innerWidth)
		if (innerHeight > 0) {
			if (innerHeight * 0.67 < innerWidth) {
				setImgWrapRefHeight(innerHeight * 0.67)
			} else {
				setImgWrapRefHeight(innerWidth)
			}
		}
	}, [innerWidth, innerHeight])

	useEffect(() => {
		if (imgWrapRef.current) {
			const leftMargin: number = Math.floor((imgWrapRef.current.clientWidth - imgWrapRef.current.clientHeight) / 2)// + 1
			setImgLeftMargin(leftMargin)
			// setFirstImgLeftMargin(((imgWrapRef.current.clientWidth - imgWrapRef.current.clientHeight) / 2) - (imgWrapRef.current.clientWidth * imgIndex))
			setFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRef.current.clientHeight) + 1 + leftMargin) * imgIndex))
			setLastFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRef.current.clientHeight) + 1 + leftMargin) * imgIndex))
		} else {
			const leftMargin: number = Math.floor((imgWrapRefWidth - imgWrapRefHeight) / 2)// + 1
			setImgLeftMargin(leftMargin)
			setFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRefHeight) + 1 + leftMargin) * imgIndex))
			setLastFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRefHeight) + 1 + leftMargin) * imgIndex))
		}
	}, [imgWrapRefWidth, imgWrapRefHeight, imgIndex])

	const updateMargins = () => {
		if (imgWrapRef.current) {
			const leftMargin: number = Math.floor((imgWrapRef.current.clientWidth - imgWrapRef.current.clientHeight) / 2)// + 1
			setImgLeftMargin(leftMargin)
			setFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRef.current.clientHeight) + 1 + leftMargin) * imgIndex))
			setLastFirstImgLeftMargin(leftMargin - ((Math.floor(imgWrapRef.current.clientHeight) + 1 + leftMargin) * imgIndex))
		}
	}

	const requestProfile = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (instructorProfileConnector.requestInProgress) {
			console.log('[AppInstructorProfile] - requestProfile() called while requestInProgress')
		} else {
			if (profileId) {
				instructorProfileConnector.getInstructorProfileRequest(profileId).then((successRequest) => {
					if (instructorStateData.profileData === undefined) {
						console.log('WARNING - [AppInstructorProfile] - requestProfile() failed, undefined result')
					} else {
						setInstructorProfileData(instructorStateData.profileData)
					}
					if (!successRequest) {
						console.log('WARNING - [AppInstructorProfile] - requestProfile() failed')
					}
				})
			}
		}
	}

	const bookNowButtonClickHandler = () => {
		if (userStateData.loggedIn) {
			const querySting: string = window.location.search;
			const urlParams: URLSearchParams = new URLSearchParams(querySting)
			const profileId: string | null = urlParams.get('id')
			// TODO: remove price setting from url string on backend
			// check to make sure price is set so it can be added to the url
			const priceInPennies: string = instructorProfileData?.price ? instructorProfileData?.price.replace('.', '') : '0'
			window.location.replace(`${PAGE_URLS.CREATE_NEW_CHAT}?instructorId=${profileId}&cost=${priceInPennies}`)
		} else {
			window.location.replace(`${PAGE_URLS.APP_LOGIN}`)
		}
	}

	const onImgTouchDown = (event: React.MouseEvent | React.TouchEvent) => {
		setImgSliding(true)
		mouseData.imageMoved = false
		const isTouchEvent = 'touches' in event
		if (isTouchEvent) {
			mouseData.mouseX = event.touches[0].screenX
			window.addEventListener('touchend', onImgTouchUp)
			window.addEventListener('touchmove', onImgTouchMove)
		} else {
			mouseData.mouseX = event.screenX
			window.addEventListener('mouseup', onImgMouseUp)
			window.addEventListener('mousemove', onImgMouseMove)
		}
	}
	const onImgMouseUp = (event: MouseEvent) => {
		finishSliderValue(event.screenX)
	}
	const onImgTouchUp = (event: TouchEvent) => {
		if (event.changedTouches.length > 0) finishSliderValue(event.changedTouches[0].screenX)
	}
	const onImgMouseMove = (event: MouseEvent) => {
		updateImgValue(event.screenX)
	}
	const onImgTouchMove = (event: TouchEvent) => {
		updateImgValue(event.touches[0].screenX)
	}
	const updateImgValue = (xPos: number) => {
		if (xPos > mouseData.mouseX + 10 || xPos < mouseData.mouseX - 10) {
			mouseData.imageMoved = true
		}
		setFirstImgLeftMargin(lastFirstImgLeftMargin + xPos - mouseData.mouseX)
	}
	const finishSliderValue = (xPos: number) => {
		setImgSliding(false)
		// console.log('xPos = ', xPos)
		// console.log('mouseData.mouseX = ', mouseData.mouseX)
		window.removeEventListener('mouseup', onImgMouseUp)
		window.removeEventListener('mousemove', onImgMouseMove)
		window.removeEventListener('touchend', onImgTouchUp)
		window.removeEventListener('touchmove', onImgTouchMove)
		if (xPos > mouseData.mouseX + 40) {
			if (imgIndex > 0) {
				setImgIndex(imgIndex - 1)
			} else {
				updateMargins()
			}
		} else if (xPos < mouseData.mouseX - 40) {
			if (instructorProfileData) {
				if (imgIndex < getProfilePicCount(instructorProfileData.profile_pics) - 1) {
					setImgIndex(imgIndex + 1)
				} else {
					updateMargins()
				}
			}
		} else {
			updateMargins()
			if (mouseData.imageMoved === false) {
				if (instructorProfileData) {
					window.location.replace(`app-instructor-pics?id=${instructorProfileData.id}`)
				}
			}
		}
	}

	const imgMemo = useMemo(
		() => ({
			width: imgWrapRefWidth > 0 ? imgWrapRefWidth : innerWidth,
			marginLeft: imgLeftMargin
		}),
		[imgWrapRefWidth, imgLeftMargin, innerWidth]
	)
	const firstImgMemo = useMemo(
		() => ({
			width: imgWrapRefWidth > 0 ? imgWrapRefWidth : innerWidth,
			marginLeft: firstImgLeftMargin,
			transition: imgSliding === true ? undefined : 'all 0.2s ease-in-out'
		}),
		[imgWrapRefWidth, firstImgLeftMargin, innerWidth, imgSliding]
	)

	return (
		<>
			<div className='section-seperator app-instructor-page-extend-margin'>
				{instructorProfileData && 
					<>
						<div 
							className='app-instructor-profile-image-wrap'
						>
							<div 
								className='app-instructor-profile-image-img-wrap'
								ref={imgWrapRef}
								onMouseDown={onImgTouchDown}
								onTouchStart={onImgTouchDown}
							>
								{getProfilePicPathArr(instructorProfileData.profile_pics).map((filePath: string, index: number) => 
									<img
										src={filePath}
										className='app-instructor-profile-image-img'
										style={index === 0 ? firstImgMemo : imgMemo}
										alt='Instructor Profile'
										key={`profileImg${index}`}
									/>
								)}
							</div>
							<a
								href={PAGE_URLS.APP_LESSONS}
								className='app-instructor-back-button'
							>
								<img
									src='/imgs/icons/shared/icon-instructor-shared-button.svg'
									alt='Back'
								/>
							</a>
							{renderProfileLikes &&
								<button
									className='app-instructor-heart-button'
									onClick={() => toggleProfileLike(instructorProfileData.id)}
								>
									<img
										src={profileIsLiked ? '/imgs/icons/instructor/icon-instructor-heart-filled-button.svg' : '/imgs/icons/instructor/icon-instructor-heart-button.svg'}
										alt='Heart'
										key={`likeIcon${renderProfileLikes}`}
									/>
								</button>
							}
							<a
								href={PAGE_URLS.SEARCH}
								className='app-instructor-message-button'
							>
								<img
									src='/imgs/icons/instructor/icon-instructor-message-button.svg'
									alt='Message'
								/>
							</a>
							<div className='app-instructor-profile-image-count'>
								{imgIndex + 1} / {getProfilePicCount(instructorProfileData.profile_pics)}
							</div>
							<div className='app-instructor-profile-image-content-bar'></div>
						</div>
						<div className='app-instructor-profile-content-wrap'>
							<div className='app-instructor-profile-name'>{instructorProfileData.name}</div>
							<div className='app-instructor-profile-general-info'>
								{instructorProfileData.gender !== undefined ? `${getGenderStringFromIndex(instructorProfileData.gender)} | ` : '| '}
								{instructorProfileData.dob !== undefined ? `${getAgeFromDateString(instructorProfileData.dob)} Years Old | ` : ''}
								{instructorProfileData.country !== undefined ? instructorProfileData.country : ''}
							</div>
							<div className='app-instructor-profile-experience-info-wrap'>
								<div className='app-instructor-profile-experience-info-item'>Level {instructorProfileData.level} CSIA</div>
								<div className='app-instructor-profile-experience-info-item'>{instructorProfileData.years_of_experience ? `${instructorProfileData.years_of_experience}+` : '?'} Years<br/>Experience</div>
							</div>
							<div className='app-instructor-profile-feedback-section-wrap'>
								<div className='app-instructor-profile-feedback-section-item'>
									<img
										className='app-instructor-profile-feedback-section-img'
										src='/imgs/icons/instructor/icon-instructor-review.svg'
										alt='Review Icon'
									/>
									{/* {instructorProfileData.review_count ? instructorProfileData.review_count : '0'} Reviews */}
									{reviewCount} Review{reviewCount !== 1 ? 's' : ''}
								</div>
								<div className='app-instructor-profile-feedback-section-item'>
									<img
										className='app-instructor-profile-feedback-section-img'
										src='/imgs/icons/instructor/icon-instructor-rating-star.svg'
										alt='Review Icon'
									/>
									{instructorProfileData.rating_overall ? instructorProfileData.rating_overall : '?'} Rating
								</div>
							</div>
							<div className='app-instructor-profile-about-section-wrap'>
								<div className='app-instructor-profile-about-title'>Meet you Instructor</div>
								<div className='app-instructor-profile-about-content'>
									{instructorProfileData.about_text && instructorProfileData.about_text.length > 0 ? 
										instructorProfileData.about_text.split('<p>').map((paragraph, index) => <p key={`aboutTxt${index}`}>{paragraph}</p>)
										:
										'No details provided'
									}
									{/* {instructorProfileData.about_text.split('<p>').map((paragraph, index) => <p key={`aboutTxt${index}`}>{paragraph}</p>)} */}
								</div>
							</div>
						</div>
						{ instructorProfileData.awards && instructorProfileData.awards.length > 0 && <InstructorProfileAwards profileData={instructorProfileData} /> }
						<InstructorProfileRating profileData={instructorProfileData} />
						<InstructorProfileReviews profileData={instructorProfileData} />
					</>
				}
				<InstructorProfileThingsToKnow />
			</div>
			<BackToTopButton />
			<div className='app-instructor-profile-cta-wrap'>
				<div className='app-instructor-profile-cta-gradient' />
				<div className='app-instructor-profile-cta-top-text'>This instructor typically replies within 6h</div>
				<div className='app-instructor-profile-cta-content'>
					<div className='app-instructor-profile-cta-content-item'>
						{/* <div className='app-instructor-profile-cta-price'>$ {Number(parseInt(instructorProfileData?.price ? instructorProfileData?.price : '0')).toFixed(2)}</div> */}
						<div className='app-instructor-profile-cta-price'>${Number(parseInt(instructorProfileData?.price ? instructorProfileData?.price : '0')).toString()}</div>
						<div className='app-instructor-profile-cta-price-label'>per session</div>
					</div>
					<div className='app-instructor-profile-cta-content-item'>
						<button 
							className={'app-instructor-profile-cta-button'}
							onClick={(event) => { 
								event.stopPropagation()
								bookNowButtonClickHandler()
							}}
						>
							<div className='app-instructor-profile-cta-button-label'>
								Book
							</div>
						</button>
					</div>
					<div className='app-instructor-profile-cta-content-item'>
						<div className='app-instructor-profile-cta-content-item-text'>Pricing<br/>explained</div>
					</div>
				</div>
				<div className='app-instructor-profile-cta-bottom-text'>You won't be charged yet</div>
			</div>
		</>
	)
}

export default AppInstructorProfile
